package com.anjuros.website.templates.template4.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.anjuros.website.templates.template4.components.Template4GalleryCard
import com.anjuros.website.templates.template4.components.Template4GalleryDescription
import com.anjuros.website.templates.template4.components.Template4ProjectCard
import com.anjuros.website.templates.template4.components.Template4SectionTitle
import com.anjuros.website.templates.template4.components.Template4ZoomOverview
import com.anjuros.website.templates.template4.modules.Template4Project
import com.anjuros.website.templates.template4.modules.Template4Section
import com.anjuros.website.templates.template4.modules.Template4Theme
import com.anjuros.website.templates.template4.styles.Template4SmallSectionWidthStyle
import com.anjuros.website.templates.template4.util.Template4Constants
import com.anjuros.website.templates.template4.util.Template4ObserverViewportEntered
import com.anjuros.website.templates.template4.util.Template4ObserverViewportEnteredForProject
import com.anjuros.website.templates.template4.util.Template4Res
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px

@Composable
fun Template4GallerySections(template4Project: Template4Project,
                             onLeftProjectArrowClicked:(template4Project: Template4Project)->Unit,
                             onRightProjectArrowClicked:(template4Project: Template4Project)->Unit){
    Box(
        modifier = Modifier
            .id(Template4Section.Gallery.id)
            .fillMaxSize()
            .padding(bottom = 100.px),
        contentAlignment = Alignment.Center
    ) {
        var imageZoomedIndex  by remember { mutableStateOf(Int.MIN_VALUE)}
        Template4GalleryContent(template4Project,
            onLeftProjectArrowClicked={onLeftProjectArrowClicked(it)},
            onRightProjectArrowClicked={onRightProjectArrowClicked(it)}){
            imageZoomedIndex=it
        }


        Template4ZoomOverview(modifier=Modifier.align(Alignment.BottomCenter),getImagePath(imageZoomedIndex,template4Project),

            onLeftClicked = {
                imageZoomedIndex--
                if (imageZoomedIndex == -1) {
                    imageZoomedIndex = template4Project.gallery.size - 1
                }
            },
            onRightClicked = {imageZoomedIndex++
                if(imageZoomedIndex>=template4Project.gallery.size){
                    imageZoomedIndex=0
                }
            },
            onExitClicked = {
                imageZoomedIndex=Int.MIN_VALUE
            })
    }
}

fun getImagePath(imageZoomedIndex:Int, template4Project: Template4Project):String{
    return if (imageZoomedIndex==Int.MIN_VALUE) ""
        else template4Project.gallery[imageZoomedIndex]
}




@Composable
fun Template4GalleryContent(template4Project: Template4Project,
                            onLeftProjectArrowClicked:(template4Project: Template4Project)->Unit,
                            onRightProjectArrowClicked:(template4Project: Template4Project)->Unit,
                            onImageClicked:(imageZoomIndex:Int)->Unit){
    val animatedMargin= remember { mutableStateOf(50.px) }
    val animatedOpacity= remember { mutableStateOf(0.0f) }
    val animatedOpacityImage = remember { mutableStateOf(0.0f) }
    val animatedOpacityImageTransition = remember { mutableStateOf(true) }



    Template4ObserverViewportEnteredForProject(
        sectionId = Template4Section.Gallery.id,
        distanceFromTop = 300.0,
        template4Project
    ){

        animatedMargin.value=10.px
        animatedOpacity.value=1.0f
        animatedOpacityImageTransition.value=true
        animatedOpacityImage.value = 1.0f

    }



    Column(
        modifier = Modifier.fillMaxSize()
        ,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Template4SectionTitle(
            modifier = Template4SmallSectionWidthStyle.toModifier()
                .margin( bottom = 75.px),
            section = Template4Section.Gallery,
            alignment = Alignment.CenterHorizontally
        )

        Template4GalleryDescription(template4Project,animatedOpacity.value,
            onLeftProjectArrowClicked={
                animatedOpacityImageTransition.value=false
                animatedOpacityImage.value=0.0f
                onLeftProjectArrowClicked(it)},
            onRightProjectArrowClicked={
                animatedOpacityImageTransition.value=false
                animatedOpacityImage.value=0.0f
                onRightProjectArrowClicked(it)
            }
        )
    SimpleGrid(numColumns = numColumns( base=1, md=2, lg=3)) {

        template4Project.gallery.forEachIndexed{ index,galleryItem ->

            Template4GalleryCard(galleryItem,index, animatedOpacityImage.value,
                animatedOpacityImageTransition.value) { onImageClicked(it) }

        }
    }


    }
}